import { Utilities } from "../Utilities";

export class CellDescriptionTooltipHelper {
    private readonly staticOffsetLeft = 10;
    private readonly staticOffsetTop = 10;
    private readonly staticOffsetRight = 10;

    private tooltipCollection: Array<TooltipElement>;
    private openingDelayMs: number;
    private closingDelayMs: number;

    constructor(openingDelayMs?: number, closingDelayMs?: number) {
        this.tooltipCollection = new Array<TooltipElement>();
        this.openingDelayMs = openingDelayMs ?? 500;
        this.closingDelayMs = closingDelayMs ?? 2000;
    }

    private static blockedElements: Array<string> = [
        'BUTTON',
        'IMG'
    ]

    /**
     * Zeigt einen Tooltip zur Offenlegung des gesamten Zelleninhalts
     * @param text Text, welcher gezeigt wird
     * @param element Über welchem Element wird gehoverd
     * @param ev Das MouseEvent
     */
    public createTooltip(text: string, element: HTMLElement, ev: MouseEvent) {
        let cellElement = $(element).closest('td')[0] as HTMLTableCellElement;

        if (cellElement) {
            if (cellElement.dataset.showsTooltip === 'true' || this.hasBlockedChildrenOrBlockedData(cellElement))
                return;

            if (!(Utilities.isNullOrEmpty(text.trim()))) {
                let tooltip = this.createTooltipElement(text, cellElement);
                tooltip.setOpenTimeoutId(window.setTimeout(() => {
                    this.setTooltipPos($(tooltip.getTooltipDiv()), ev);
                    tooltip.showTooltip();

                    tooltip.setCloseDelayTimeoutId(window.setTimeout(() => {
                        tooltip.hideTooltip();
                        this.disposeTooltip(tooltip.getCellElement());
                    }, this.closingDelayMs));
                }, this.openingDelayMs));
            }
        }
    }

    /**
     * Entfernt alle noch offenen Tooltips
     * @param bindedCell Zelle welche gerade für den Tooltip verwendet wird
     */
    public disposeTooltip(bindedCell: HTMLTableCellElement): void {
        for (let i = 0; i < this.tooltipCollection.length; i++) {
            let tooltip = this.tooltipCollection[i];
            if (!tooltip.getTooltipDiv().isEqualNode(bindedCell)) {
                this.cleanDom(tooltip);
            }
        }
    }

    public dispose(): void {
        for (let i = 0; i < this.tooltipCollection.length; i++) {
            let tooltip = this.tooltipCollection[i];
                
            this.cleanDom(tooltip);
        }
    }

    private hasBlockedChildrenOrBlockedData(tdElem: HTMLTableCellElement): boolean {
        let childs = $(tdElem).children();
        if (childs.length > 0) {
            if (CellDescriptionTooltipHelper.blockedElements.includes(childs[0].tagName) || childs[0].dataset.noGridTooltip === 'true') {
                return true;
            }
        }

        return false;
    }

    private cleanDom(tooltip: TooltipElement) {
        window.clearTimeout(tooltip.getOpenTimeoutId());
        window.clearTimeout(tooltip.getCloseDelayTimeoutId());
        $(tooltip.getTooltipDiv()).remove();
    }

    private createTooltipElement(text: string, cellToBind: HTMLTableCellElement): TooltipElement {
        let uniqueId = this.generateUniqueId();
        let tooltipElement = document.createElement('div');
        tooltipElement.classList.add('c-celltooltip');
        tooltipElement.textContent = text;
        tooltipElement.id = uniqueId;
        tooltipElement.style.display = 'none';
        
        let tooltip = new TooltipElement(uniqueId, tooltipElement, cellToBind);
        this.tooltipCollection.push(tooltip);
        document.getElementsByTagName('body')[0].appendChild(tooltip.getTooltipDiv());

        return tooltip;
    }

    private setTooltipPos(tooltipElement: JQuery<HTMLDivElement>, ev: MouseEvent) {
        let w = $(window);
        let heightFromTop = w.height() + w.scrollTop();
        let widthFromLeft = w.width() + w.scrollLeft();
        let width = tooltipElement.outerWidth();
        let height = tooltipElement.outerHeight();

        this.positionTooltip(tooltipElement, ev.pageY, ev.pageX, height, width, heightFromTop, widthFromLeft);
    }

    private positionTooltip(tooltip: JQuery<HTMLElement>, top: number, left: number, height: number, width: number, heightFromTop: number, widthFromLeft: number) {
        let tooltipWidth = window.innerWidth / 2;

        if (top + height + this.staticOffsetTop >= heightFromTop) {
            top = top - height - this.staticOffsetTop;
        } else
            top = top + this.staticOffsetTop;

        if (left + width + this.staticOffsetLeft >= widthFromLeft) {
            if (left - width - this.staticOffsetLeft >= this.staticOffsetLeft) {
                left = left - width - this.staticOffsetLeft;
            } else {
                if (left < widthFromLeft / 2) {
                    left = left + this.staticOffsetLeft;
                } else {
                    left = window.innerWidth - tooltipWidth - this.staticOffsetRight;
                }
                
                width = tooltipWidth;
            }
        } else {
            left = left + this.staticOffsetLeft;
        }

        tooltip.css({
            top: `${top}px`,
            left: `${left}px`,
            width: `${width}px`
        });
    }

    private generateUniqueId(): string {
        return "tooltip" + Math.random().toString(12).slice(8);
    }
}

class TooltipElement {
    private tooltipId: string;
    private tooltipDiv: HTMLDivElement;
    private cell: HTMLTableCellElement;
    private timeoutIdOpen: number;
    private timeoutIdCloseDelay: number;

    constructor(tooltipId: string, tooltipDiv: HTMLDivElement, cell: HTMLTableCellElement) {
        this.tooltipId = tooltipId;
        this.tooltipDiv = tooltipDiv;
        this.cell = cell;
        this.timeoutIdOpen = null;
        this.timeoutIdCloseDelay = null;
    }

    public getTooltipId(): string {
        return this.tooltipId;
    }

    public getTooltipDiv(): HTMLDivElement {
        return this.tooltipDiv;
    }

    public getCellElement(): HTMLTableCellElement {
        return this.cell;
    }

    public getOpenTimeoutId(): any {
        return this.timeoutIdOpen;
    }

    public setOpenTimeoutId(id: any): any {
        return this.timeoutIdOpen = id;
    }

    public getCloseDelayTimeoutId(): any {
        return this.timeoutIdCloseDelay;
    }

    public setCloseDelayTimeoutId(id: any): any {
        return this.timeoutIdCloseDelay = id;
    }

    public showTooltip() {
        this.tooltipDiv.style.display = 'block';
    }

    public hideTooltip() {
        this.tooltipDiv.style.display = 'none';
    }
}